import React, { Component } from 'react';
import classNames from 'classnames';
import { withUser } from '../../modules/User';

class AppInlineProfile extends Component {
  state = {
    expanded: false
  };

  onClick = (event) => {
    this.setState({ expanded: !this.state.expanded });
    event.preventDefault();
  }

  render() {
    const { user } = this.props;
    if (!user) return null;
    return (
      <div>
        <div className={classNames('profile', {'profile-expanded': this.state.expanded})}>
          <button className="p-link" onClick={this.onClick}>
            <img alt="Profile" className="profile-image" src="assets/layout/images/abrange.png" />
            <span className="profile-name">{user.username}</span>
            <i className="fa fa-fw fa-caret-down" />
            <span className="profile-role">{user.id}</span>
          </button>
        </div>
        <ul className="layout-menu profile-menu">
          <li role="menuitem">
            <button className="p-link"  tabIndex={this.state.expanded ? null : '-1'}>
              <i className="fa fa-fw fa-sign-out"></i>
              <span>Sair</span>
            </button>
            <div className="layout-menu-tooltip">
              <div className="layout-menu-tooltip-arrow"></div>
              <div className="layout-menu-tooltip-text">Sair</div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default withUser(AppInlineProfile);
